import type {
  DataPointCategory,
  DataPointColumn,
  DataPointKind,
  MessageTemplateReportType
} from '@gcv/shared';
import { injectable } from 'inversify';

import { banksApi } from './api-util/api';

/**
 * A single insertable token from the Builder's data-point catalog. Mirrors the
 * `GET /banks/:id/data-points` response entry (a trimmed projection of the full DataPoint).
 */
export interface DataPointResponse {
  /** Data point name (snake_case); becomes the token's {{id}} marker. */
  key: string;
  /** Server-humanized display label. */
  label: string;
  /** Scalar (inline chip) vs table (block section token). */
  kind: DataPointKind;
  /** Grouping for the picker. */
  category: DataPointCategory;
  /** Column definitions, present only for table-kind data points. */
  table_columns?: DataPointColumn[];
}

@injectable()
export class DataPointsApi {
  /** Catalog of insertable tokens for a report type, for the Builder's "Insert Data Point" picker. */
  async getDataPoints(bankId: string, reportType: MessageTemplateReportType): Promise<DataPointResponse[]> {
    return await banksApi().get(`/banks/${bankId}/data-points`, { reportType });
  }
}
